import React, { useEffect,useRef } from "react";
import { useDrag } from 'react-dnd';
import "./ActiveTaskCard.scss";
import RoCard from "./RoCard";

const ActiveTaskCard = ({ task, index, whenDragging, whenDragEnd,reloadData }) => {
  const dragRef = useRef(null);
  const [{ isDragging }, drag,preview] = useDrag(() => ({
    type: 'task',
    item: { task, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    
    end: (item, monitor) => {
      document.body.classList.remove('noselect');
      whenDragEnd()
    },
    canDrag: (monitor) => {
      const element = dragRef.current;
      if (element) {
        const { left, right, top, bottom } = element.getBoundingClientRect();
        const clientX = monitor.getClientOffset().x;
        const clientY = monitor.getClientOffset().y;
        const restrictedArea = {
          top: 0,
          left: right - 100,
          right: right,
          bottom: bottom ,
        };
  
        if (
          clientX >= restrictedArea.left &&
          clientX <= restrictedArea.right &&
          clientY >= restrictedArea.top &&
          clientY <= restrictedArea.bottom
        ) {
          return false; // Restrict dragging
        }
      }
      return   true; // Allow dragging
    },
  }));
  drag(preview(dragRef));
  useEffect(() => {
    if (isDragging) {
      document.body.classList.add('noselect');
      whenDragging()
    }

    
  }, [isDragging]);
  return (
    <div
      ref={drag}
      className={isDragging?"dragItem dragging":"dragItem"}
    >
      <div
      ref={dragRef}>
      <RoCard task={task} reloadData={reloadData}/>
      </div>
    </div>
  );
};

export default ActiveTaskCard;
